module.exports = __webpack_public_path__ + "static/media/gcdef_112.6f51875b.ico";